<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div
      style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden"
    >
      <userLeft :active="6" />
      <div class="box5" style="position: relative">
        <div class="box6">我的足迹</div>
        <div class="box7"></div>

        <div style="overflow: hidden; margin-top: 2%">
          <div style="overflow: hidden">
            <div class="box11" style="float: left" @click="piliangshangchu">
              批量删除
            </div>
            <!-- <div style="float: left; margin-left: 2%; margin-top: 1%">
              <a-checkbox > 全选 </a-checkbox>
            </div> -->
          </div>

            <div>
              <div style="overflow: hidden; margin-top: 2%">
            <div class="box17">
              <span style="font-size: 30px">今天</span
              ><span style="font-size: 14px">{{jintian}}</span>
            </div>
            <div class="box18"></div>
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <a-row :gutter="16">
              <a-col class="gutter-row" :span="8" :key="index" v-for="(item,index) in list1">
                <div class="gutter-box box13">
                  <div class="box14 siderbarTitle" style="text-align: left">
                    {{ item.goodsName }}
                  </div>
                  <div style="overflow: hidden; margin-top: 4%">
                    <img v-if="item.cover"
                      :src="'/api/file/preview/' + item.cover"
                      style="width: 100px; height: 100px; float: left"
                      alt=""
                    />
                    <div style="float: left; margin-left: 2%; float: left; width: 60%;">
                      <div style="margin-left: 4%; text-align: left">
                        <div class="box15">
                          <div style="margin-top: 10px;" class="siderbarTitle">品牌：{{item.brand}}</div>
                          <div style="margin-top: 10px;" class="siderbarTitle">CAS号：{{ item.casNum }}</div>
                        </div>
                        <div
                          class="box16"
                          @click="to_goods_details(item.goodsId)"
                        >
                          立即购买
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="close_box" @click="shanchu(item)">x</div>
                </div>
              </a-col>
            </a-row>
            <div
              v-if="list1.length == 0"
              style="margin-top: 40px; text-align: center"
            >
              没有记录~
            </div>
          </div>
            </div>


                        <div>
              <div style="overflow: hidden; margin-top: 2%">
            <div class="box17">
              <span style="font-size: 30px">昨天</span
              ><span style="font-size: 14px">{{zuotian}}</span>
            </div>
            <div class="box18"></div>
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <a-row :gutter="16">
              <a-col class="gutter-row" :span="8" :key="index" v-for="(item,index) in list2">
                <div class="gutter-box box13">
                  <div class="box14 siderbarTitle" style="text-align: left">
                    {{ item.goodsName }}
                  </div>
                  <div style="overflow: hidden; margin-top: 4%">
                    <img v-if="item.cover"
                      :src="'/api/file/preview/' + item.cover"
                      style="width: 100px; height: 100px; float: left"
                      alt=""
                    />
                    <div style="float: left; margin-left: 2%; float: left; width: 60%;">
                      <div style="margin-left: 4%; text-align: left">
                        <div class="box15">
                          <div style="margin-top: 10px;" class="siderbarTitle">品牌 {{item.goodsName}}</div>
                          <div style="margin-top: 10px;" class="siderbarTitle">CAS号：{{ item.casNum }}</div>
                        </div>
                        <div
                          class="box16"
                          @click="to_goods_details(item.goodsId)"
                        >
                          立即购买
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="close_box" @click="shanchu(item)">x</div>
                </div>
              </a-col>
            </a-row>
            <div
              v-if="list2.length == 0"
              style="margin-top: 40px; text-align: center"
            >
              没有记录~
            </div>
          </div>
            </div>

                        <div>
              <div style="overflow: hidden; margin-top: 2%">
            <div class="box17">
              <span style="font-size: 30px">更早</span
              ><span style="font-size: 14px">{{gengzao}}</span>
            </div>
            <div class="box18"></div>
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <a-row :gutter="16">
              <a-col class="gutter-row" :span="8" :key="index" v-for="(item,index) in list3">
                <div class="gutter-box box13">
                  <div class="box14" style="text-align: left">
                    {{ item.goodsName }}
                  </div>
                  <div style="overflow: hidden; margin-top: 4%">
                    <img v-if="item.cover"
                      :src="'/api/file/preview/' + item.cover"
                      style="width: 100px; height: 100px; float: left"
                      alt=""
                    />
                    <div style="float: left; margin-left: 2%; float: left;width: 60%;">
                      <div style="margin-left: 4%; text-align: left">
                        <div class="box15">
                          <div>品牌：科试</div>
                          <div style="margin-top: 10px;">CAS号：{{ item.casNum }}</div>
                        </div>
                        <div
                        style="margin-top: 10px;"
                          class="box16"
                          @click="to_goods_details(item.goodsId)"
                        >
                          立即购买
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="close_box" @click="shanchu(item)">x</div>
                </div>
              </a-col>
            </a-row>
            <div
              v-if="list3.length == 0"
              style="margin-top: 40px; text-align: center"
            >
              没有记录~
            </div>
          </div>
            </div>

        </div>

<div style="position: absolute; bottom: 2%; width: 100%;display: flex;justify-content: center;align-items: center;bottom:0;margin:10px 0">
          <a-pagination
            show-quick-jumper
            :default-current="1"
            :total="totalPages*10"
            @change="fanye"
          />
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";
export default {
  name: "integral",
  components: {
    userLeft,
    htmlHeader,
    foot,
  },
  data() {
    return {
      totalPages: 1,//总页数
      list: [],
      page: 0,
      size:10,
      list1: [],
      list2: [],
      list3: [],

      jintian: '',
      zuotian: '',
      gengzao: '',
    };
  },
  methods: {
    fanye(e) {
      this.page = e - 1
      this.get_list()
    },
    // 获取今天昨天的日期
    get_riqi() {
      //昨天的时间
      var day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      let _t1 = day1.getFullYear()
      let _t2 = day1.getMonth() + 1
      let _t3 = day1.getDate()
      if(_t2 < 10) {
        _t2 = '0' + _t2
      }
      if(_t3 < 10) {
        _t3 = '0' + _t3
      }
      this.zuotian = _t1 + '-' + _t2 + '-' + _t3
      //今天的时间
      var day2 = new Date();
      day2.setTime(day2.getTime());

        let t1 = day2.getFullYear()
      let t2 = day2.getMonth() + 1
      let t3 = day2.getDate()
      if(t2 < 10) {
        t2 = '0' + t2
      }
      if(t3 < 10) {
        t3 = '0' + t3
      }
      this.jintian = t1 + '-' + t2 + '-' + t3
    },
    delete_footprint(id) {
      this.api.delete_footprint(id.join(",")).then((res) => {
        if (res.ok) {
          this.$message.success(res.message);
          this.get_list();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 批量删除
    piliangshangchu() {
      const that = this;
      let uuids = [];
      this.list.forEach((element) => {
        uuids.push(element.uuid);
      });
      console.log(uuids);
      that.$confirm({
        title: `是否清空全部足迹?`,
        onOk() {
          // uuids
          that.delete_footprint(uuids);
        },
      });
    },
    // 去商品详情页
    to_goods_details(e) {
      this.$router.push("/goods_details?uuid=" + e);
    },
    // 删除
    shanchu(e) {
      const that = this;
      that.$confirm({
        title: `是否删除足迹${e.goodsName}?`,
        onOk() {
          // e.uuid
          that.delete_footprint([e.uuid]);
        },
      });
    },
    // 获取数据
    get_list() {
      this.api.get_footprint({ page: this.page,size: this.size }).then((res) => {
        if (res.ok) {
          console.log('time', res.data);
          this.list = res.data.content
          this.totalPages = res.data.totalPages
          this.list1 = []
          this.list2 = []
          this.list3 = []
          res.data.content.forEach(element => {
            let item_riqi = element.updatedAt.slice(0, 10)
            if(item_riqi == this.jintian) {
              this.list1.push(element)
            }else if(item_riqi == this.zuotian) {
              this.list2.push(element)
            }else {
              this.gengzao = item_riqi
              console.log(this.gengzao);
              this.list3.push(element)
            }
          });
        } else {
          this.$message.error(res.message)
        }
      });
    },
  },
  created() {
    this.get_list();
    this.get_riqi()
  },
};
</script>

<style scoped>
.siderbarTitle{
  width: 150px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
 .siderbarTitle:hover{
  overflow: visible;
  animation: 3s siderbar linear infinite normal;
  z-index: 0;
  }
.box13:hover .close_box {
  display: block;
}
.box13:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
  transition: all 1s;
}
.close_box {
  width: 20px;
  transition: all 1s;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  line-height: 20px;
  color: #fff;
  background: #ede9e9;
  display: none;
}
.box18 {
  width: 80%;
  height: 1px;
  float: right;
  margin-top: 3%;
  border-top: 1px solid #e0e0e0;
}
.box17 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2c9a34;
  float: left;
}
.box16 {
  width: 80px;
  height: 32px;
  border: 1px solid #2b9a34;
  text-align: center;
  line-height: 32px;

  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
  margin-top: 4%;
  cursor: pointer;
}
.box15 {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.box14 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
}
.box13 {
  width: 100%;
  height: 167px;
  background: #ffffff;
  border: 1px solid #ede9e9;
  padding: 4%;
  position: relative;
  margin-top: 20px;
  cursor: pointer;
}
.box12 {
  width: 120px;
  height: 32px;
  border: 1px solid #ede9e9;
  float: left;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  text-align: center;
  line-height: 32px;
}
.box11 {
  width: 100px;
  height: 32px;
  border: 1px solid #2b9a34;

  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.box10 {
  width: 100%;
  height: 1px;
  border: 1px dashed #e8e6e6;
  margin-top: 2%;
}
.box9 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  float: left;
  margin-left: 2%;
}
.box8 {
  width: 96%;
  height: 130px;
  border: 1px solid #e8e6e6;
  margin-top: 2%;
  padding: 2%;
}

.box7 {
  width: 100%;
  height: 1px;
  border-top: 1px dashed #e8e6e6;
  margin-top: 2%;
}

.box6 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  /* margin-top: 2%; */
  text-align: left;
}

.box5 {
  width: 80%;
  min-height: 1023px;
  border: 1px solid #ede9e9;
  float: right;
  margin-top: 2%;
  padding: 2%;
  padding-bottom: 50px;
}

.box3 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: Regular;
  color: #666666;
  margin-top: 6%;
}

.box4 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.box1 {
  width: 220px;
  min-height: 1023px;
  border: 1px solid #ede9e9;
  float: left;
  margin-top: 2%;
}

.box2 {
  width: 100%;
  height: 45px;
  background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/footprint.vue